import { render, staticRenderFns } from "./RecommendationsAccordion.vue?vue&type=template&id=c6cad90a&scoped=true&"
import script from "./RecommendationsAccordion.vue?vue&type=script&lang=js&"
export * from "./RecommendationsAccordion.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationsAccordion.vue?vue&type=style&index=0&id=c6cad90a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6cad90a",
  null
  
)

export default component.exports